let PaymentMethods = {
	VISA: {id:1, type: 'credit-card', name: 'Visa'},
  MASTER: {id:2, type: 'credit-card', name: 'Master'},
  AMEX: {id:3, type: 'credit-card', name: 'Amex'},
  BANK_TICKET: {id: 4, type: 'bank-ticket', name: null},
};

export default PaymentMethods;
export const paymentMethods = Object.keys(PaymentMethods).map(key => PaymentMethods[key]);



// WEBPACK FOOTER //
// ./src/enums/PaymentMethods.js